import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { List, Paper } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import InputSlider from './CustomSlider';
import { FaBiohazard } from 'react-icons/fa';
import SpeedIcon from '@material-ui/icons/Speed';
import PeopleIcon from '@material-ui/icons/People';
import { GiDeathSkull } from 'react-icons/gi';
import TimerIcon from '@material-ui/icons/Timer';
import PersonIcon from '@material-ui/icons/Person';
import Info from './Info';
import DialogForEdge from './DialogForEdgeUsers';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
}));

const titles = {
    sld0: {
        title: 'Personenanzahl (gesamt)',
        descr: 'Die Personenzahl legt fest, wie viele Personen (Kreise) und deren Bewegung insgesamt simuliert werden sollen. Damit kann die Simulation sowohl für dünn als auch für dicht besiedelte Gebiete verwendet werden.',
    }, sld1: {
        title: '...davon Gruppe 1 [%]',
        descr: 'Die Personen (Kreise) werden zufällig einer von zwei Gruppen zugeordnet. Wie groß die jeweilige Gruppe im Verhältnis zur gesamten Personenzahl sein soll, kann hier eingestellt werden. Ein Wert von 50% teilt dabei alle Personen in zwei gleich große Gruppen ein.',
    }, sld2: {
        title: 'mit Geschwindigkeit 1',
        descr: 'Jede Person (Kreis) bewegt sich mit der Geschwindigkeit ihrer zufällig zugeteilten Gruppe, welche hier eingestellt werden kann. Damit kann beispielsweise die Auswirkung von Heimarbeit (Gruppe mit niedriger Geschwindigkeit) simuliert werden',
    }, sld3: {
        title: '...davon Gruppe 2 [%]',
        descr: 'Die Personen (Kreise) werden zufällig einer von zwei Gruppen zugeordnet. Wie groß die jeweilige Gruppe im Verhältnis zur gesamten Personenzahl sein soll, kann hier eingestellt werden. Ein Wert von 50% teilt dabei alle Personen in zwei gleich große Gruppen ein.',
    }, sld4: {
        title: 'mit Geschwindigkeit 2',
        descr: 'Jede Person (Kreis) bewegt sich mit der Geschwindigkeit ihrer zufällig zugeteilten Gruppe, welche hier eingestellt werden kann. Damit kann beispielsweise die Auswirkung von Heimarbeit (Gruppe mit niedriger Geschwindigkeit) simuliert werden.',
    }, sld5: {
        title: 'Genesungsdauer [Tage]',
        descr: 'Die Genesungsdauer legt fest, wie lange eine infizierte Person (blauer Kreis) in diesem Zustand bleibt, bevor sie entweder genest (grüner Kreis) oder verstirbt (schwarzer Kreis). Ein Wert von 14 Tagen entspricht dabei 14 Sekunden in der Simulation.',
    }, sld6: {
        title: 'Infektionsrisiko [%]',
        descr: 'Das Infektionsrisiko beschreibt, mit welcher Wahrscheinlichkeit sich eine gesunde Person (weißer Kreis) bei einer infizierten (blauer Kreis) bei Kontakt (Zusammenstoß) ansteckt. Ein Wert von 50% bedeutet, dass im Mittel nur jeder zweite Zusammenstoß zu einer Infektion führt.',
    }, sld7: {
        title: 'Mortalität [%]',
        descr: 'Die Mortalität beschreibt, mit welcher Wahrscheinlichkeit eine infizierte Person (blauer Kreis) stirbt (schwarzer Kreis). Ein Wert von 10% bedeutet, dass im Mittel einer von zehn Infizierten stirbt.',
    },
}

export default class Menu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            percent1: this.props.settings.percent1 ? this.props.settings.percent1 : 20,
            percent2: this.props.settings.percent2 ? this.props.settings.percent2 : 20,
            speed1: this.props.settings.speed1 ? this.props.settings.speed1 : 20,
            speed2: this.props.settings.speed2 ? this.props.settings.speed2 : 20,
            amount: this.props.settings.amount ? this.props.settings.amount : 20,
            time: this.props.settings.time ? this.props.settings.time : 20,
            infectionRate: this.props.settings.infectionRate ? this.props.settings.infectionRate : 20,
            mortality: this.props.settings.mortality ? this.props.settings.mortality : 20,
            height: props.height,
            width: props.width,
        }
    }

    valueChanged = (newValue, index) => {
        this.setState({
            amount: Number(index) === 0 ? newValue : this.state.amount,
            percent1: Number(index) === 1 ? newValue : (Number(index) === 3 ? 100 - newValue : this.state.percent1),
            speed1: Number(index) === 2 ? newValue : this.state.speed1,
            percent2: Number(index) === 3 ? newValue : (Number(index) === 1 ? 100 - newValue : this.state.percent2),
            speed2: Number(index) === 4 ? newValue : this.state.speed2,
            time: Number(index) === 5 ? newValue : this.state.time,
            infectionRate: Number(index) === 6 ? newValue : this.state.infectionRate,
            mortality: Number(index) === 7 ? newValue : this.state.mortality,
            height: this.state.height,
            width: this.state.width,
        }, () => {
            this.props.valueChanged(this.state);
            this.refs.paper.maxHeight = this.state.height;
            this.refs.paper.width = this.state.width;
            if (Number(index) === 1 && this.state.callbackTwo) this.state.callbackTwo(100 - newValue);
            if (Number(index) === 3 && this.state.callbackOne) this.state.callbackOne(100 - newValue);
        })
    }

    setCallbackTwo = (method) => {
        if (!this.state.callbackTwo) this.setState({ callbackTwo: method });
    };
    setCallbackOne = (method) => {
        if (!this.state.callbackOne) this.setState({ callbackOne: method });
    };

    getValFor = (index) => {
        switch (Number(index)) {
            case 0:
                return this.state.amount;
            case 1:
                return this.state.percent1;
            case 2:
                return this.state.speed1;
            case 3:
                return this.state.percent2;
            case 4:
                return this.state.speed2;
            case 5:
                return this.state.time;
            case 6:
                return this.state.infectionRate;
            case 7:
                return this.state.mortality;
            default:
                return 0;
        }
    }

    isEdge = () => {
        //source -> https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser

        navigator.sayswho = (function () {
            var ua = navigator.userAgent, tem,
                M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if (/trident/i.test(M[1])) {
                tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                return 'IE ' + (tem[1] || '');
            }
            if (M[1] === 'Chrome') {
                tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
                if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
            }
            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
            if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
            return M.join(' ');
        })();

        console.log(navigator.sayswho);

        return navigator.sayswho.split(' ')[0] === 'Edge' && Number(navigator.sayswho.split(' ')[1]) < 18;
    }

    render() {
        return (
            <div className={useStyles.root}>
                {this.isEdge() ? <DialogForEdge /> : null}
                <Paper id='style-3' variant="outlined" square ref='paper' style={{ height: this.state.height, width: this.state.width, overflowY: 'auto', overflowX: 'hidden', alignContent: 'center' }}>
                    <List>
                        <Info information={titles.sld0} marginTop={this.isEdge() ? '4px' : '0px'} />
                        <InputSlider min={1} icon={PersonIcon} title={titles.sld0.title} initialValue={this.getValFor(0)} index={0} max={250} valueChanged={this.valueChanged} />
                        <div style={{ height: '0.8em' }} />
                        <Divider />
                        <div style={{ height: '0.8em' }} />
                        <Info information={titles.sld1} />
                        <InputSlider icon={PeopleIcon} setCallback={this.setCallbackOne} title={titles.sld1.title} initialValue={this.getValFor(1)} index={1} valueChanged={this.valueChanged} />
                        <Info information={titles.sld2} marginTop='3px' />
                        <InputSlider icon={SpeedIcon} title={titles.sld2.title} initialValue={this.getValFor(2)} index={2} valueChanged={this.valueChanged} />
                        <div style={{ height: '0.8em' }} />
                        <Divider />
                        <div style={{ height: '0.8em' }} />
                        <Info information={titles.sld3} />
                        <InputSlider icon={PeopleIcon} setCallback={this.setCallbackTwo} title={titles.sld3.title} initialValue={this.getValFor(3)} index={3} valueChanged={this.valueChanged} />
                        <Info information={titles.sld4} marginTop='3px' />
                        <InputSlider icon={SpeedIcon} title={titles.sld4.title} initialValue={this.getValFor(4)} index={4} valueChanged={this.valueChanged} />
                        <div style={{ height: '0.8em' }} />
                        <Divider />
                        <div style={{ height: '0.8em' }} />
                        <Info information={titles.sld5} />
                        <InputSlider min={1} icon={TimerIcon} title={titles.sld5.title} initialValue={this.getValFor(5)} index={5} valueChanged={this.valueChanged} />
                        <div style={{ height: '0.8em' }} />
                        <Divider />
                        <div style={{ height: '0.8em' }} />
                        <Info information={titles.sld6} />
                        <InputSlider icon={FaBiohazard} title={titles.sld6.title} initialValue={this.getValFor(6)} index={6} valueChanged={this.valueChanged} />
                        <div style={{ height: '0.8em' }} />
                        <Divider />
                        <div style={{ height: '0.8em' }} />
                        <Info information={titles.sld7} />
                        <InputSlider icon={GiDeathSkull} title={titles.sld7.title} initialValue={this.getValFor(7)} index={7} valueChanged={this.valueChanged} />
                    </List>
                </Paper>
            </div>
        );
    }
}
